import { render, staticRenderFns } from "./404New.vue?vue&type=template&id=2b8dc0a1&scoped=true&"
import script from "./404New.vue?vue&type=script&lang=ts&"
export * from "./404New.vue?vue&type=script&lang=ts&"
import style0 from "./404New.vue?vue&type=style&index=0&id=2b8dc0a1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8dc0a1",
  null
  
)

export default component.exports